import { ListItemText } from "@mui/material";
import React from "react";

import type { SidebarMenuItemTextProps } from "./types";
import { sidebarTheme } from "@/styles/sidebarTheme";

export const SidebarMenuItemText: React.FC<SidebarMenuItemTextProps> = ({
  text,
  isSelected,
  level = 0,
}) => {
  const isTopLevel = level === 0;

  return (
    <ListItemText
      primary={text}
      sx={{
        "& .MuiListItemText-primary": {
          color: isSelected
            ? sidebarTheme.menu.selected.text
            : sidebarTheme.menu.normal.text,
          fontWeight: isSelected ? 600 : isTopLevel ? 500 : 400,
          fontSize: isTopLevel ? "0.95rem" : "0.875rem",
          lineHeight: 1.3,
        },
        whiteSpace: "normal",
        overflow: "hidden",
        wordWrap: "break-word",
      }}
    />
  );
};
